import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { DashboardService } from 'src/app/providers/dashboard/dashboard.service';
import { LeaveService } from 'src/app/providers/leave/leave.service';
import { TalentService } from 'src/app/providers/talent/talent.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';
import { GeneralService } from 'src/app/providers/general/general.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
declare let $: any;

@Component({
  selector: 'app-all-approval',
  templateUrl: './all-approval.component.html',
  styleUrls: ['./all-approval.component.scss'],
})
export class AllApprovalComponent implements OnInit {
  isLoading: boolean = true;
  public marqueeText = '';
  leavesData: any = [];
  public attRegulariseDataCount: any = 0;
  public page = 1;
  public count = 0;
  public pageSize = 10;
  public from;
  public to;
  public response: any = [];
  result: any = [];
  attRegulariseData: any = [];
  minDate: any;
  public mrfApprovalsCount = 0;
  mrfApprovalsCountEmp = 0;
  transferApprovalsCount = 0;
  transferApprovalsCountEmp = 0;
  public exitApprovalsCount = 0;
  exitApprovalsCountEmp = 0;
  expensesCount: any = 0;
  expensesCountEmp = 0;
  smarttripCountEmp = 0;
  smarttripCount: any = 0;
  public awardApprovalsCount = 0;
  awardApprovalsCountEmp = 0;
  public idCardApprovalsCount = 0;
  idCardApprovalsCountEmp = 0;
  public epaApprovalsCount = 0;
  public epaApprovals: any = [];
  pettyCashApprovalCount = 0;
  pettyCashExpenseApprovalCount = 0;
  public workPlaceApprovalsCount = 0;
  workPlaceApprovalsCountEmp = 0;
  public mrfApprovals: any = [];
  approvals: any = [];
  ftcRenewalCount = 0;
  transferApprovals: any;
  loadingBulkApprove = false;
  public regulariseFrom: FormGroup;
  submit = false;
  public mrfApproveForm: FormGroup;
  public exitApprovals: any = [];
  exitRejectForm: FormGroup;
  public exitApproveForm: FormGroup;
  exitReject = false;
  encMrfId: any;
  exitUpdateForm: FormGroup;
  extendExit: FormGroup;
  public resolveFormExpense: FormGroup;
  public resolveForm: FormGroup;
  public idCardApprovals: any = [];
  voltryList: any = [];
  reasonList: any = [];
  loading = false;
  awardData: any;
  btnName = 'Approve';
  expenseData: any;
  submitExp = false;
  updateExitDate = false;
  updateExit = false;
  visitingCardApprovalsCount = 0;
  public visitingCardApprovals: any = [];
  pettyCashExpenseApprovals: any = [];
  pettyCashApprovals: any = [];
  awardApprovals: any = [];
  pettyReqRejRemark;
  pettyExpnsRejRemark;
  pettyApprObj: any;
  pettyExpnsApprObj: any;
  napsMrfApprovalsCount = 0;
  napsMrfApprovals: any = [];
  expenseApprovals: any = [];
  smarttripApprovals: any = [];
  resolveAction: any = [
    { label: 'Approve', value: 1 },
    { label: 'Reject', value: 0 },
  ];
  ongcpassCount = 0;
  ongcApprovals: any;

  pendingEmpBuddyCount = 0;
  buddyPendingEmployeeList: any = [];
  committeeDataCount:any = [];
  committeeData:any = [];
  commt_remark;

  constructor(
    private dashboardService: DashboardService,
    private notifyService: NotificationService,
    private leaveServe: LeaveService,
    private talentService: TalentService,
    private router: Router,
    private generalServ: GeneralService,
    private formBuilder: FormBuilder
  ) {
    this.minDate = moment().startOf('month').format('YYYY-MM-DD');
  }

  ngOnInit(): void {
    this.resolveFormFieldExpense();
    this.LeaveRegister();
    this.getAttendanceReguarisationRequest();
    this.getMyApprovals();
    this.regulariseFormFields();
    this.createMrfApproveForm();
    this.resolveFormFields();
    this.exitDateFormInit();
    this.exitUpdateFormInit();
    this.exitRejectRemarkForm();
    this.exitApproveFormField();
  }

  onInput(event): void {
    if (event.target.value.length === 0) {
      this.exitUpdateForm.patchValue({
        rpls_rm_id: '',
      });
    }
  }

  get resolveErrorMsg(): any {
    return this.resolveForm.controls;
  }

  get regulariseErrorMsg(): any {
    return this.regulariseFrom.controls;
  }

  exitUpdateFormInit(): void {
    this.exitUpdateForm = this.formBuilder.group({
      exit_id: [''],
      vltry_id: ['', Validators.required],
      rsn_id: ['', Validators.required],
      rpls_rm_username: [''],
      rpls_rm_id: [''],
    });
  }

  regulariseFormFields(): void {
    this.regulariseFrom = this.formBuilder.group({
      status: ['', Validators.required],
      remark: ['', Validators.required],
      txn_id: ['', Validators.required],
    });
  }

  resolveFormFieldExpense(): void {
    this.resolveFormExpense = new FormGroup({
      is_approved: new FormControl('', Validators.required),
      remark: new FormControl('', Validators.required),
    });
  }

  takeAction(event): void {
    console.log('uy', event.target.value);
    if (event.target.value == 1) {
      this.btnName = 'Approve';
    } else if (event.target.value == 0) {
      this.btnName = 'Reject';
    }
  }

  createMrfApproveForm(): void {
    this.mrfApproveForm = new FormGroup({
      remark: new FormControl(''),
      rel_id: new FormControl('', Validators.required),
      status: new FormControl('', Validators.required),
      rel_group_id: new FormControl('', Validators.required),
      txn_id: new FormControl('', Validators.required),
    });
  }

  exitDateFormInit(): void {
    this.extendExit = this.formBuilder.group({
      exit_id: [''],
      ext_date: ['', Validators.required],
    });
  }

  resolveFormFields(): void {
    this.resolveForm = this.formBuilder.group({
      is_approved: ['', Validators.required],
      remark: ['', Validators.required],
    });
  }

  exitRejectRemarkForm(): void {
    this.exitRejectForm = this.formBuilder.group({
      exit_id: [''],
      status: [''],
      rel_id: [''],
      emp_user_id: [''],
      approver_remark: ['', Validators.required],
    });
  }

  get exitRemarkErrorMsg(): any {
    return this.exitRejectForm.controls;
  }

  get exitDateErrorMsg(): any {
    return this.extendExit.controls;
  }

  get expErrorMsg(): any {
    return this.resolveFormExpense.controls;
  }

  checkUncheckAllVisitCard(event): void {
    // console.log(event.target.checked);
    const checked = event.target.checked;
    this.visitingCardApprovals.forEach((item) => (item.isSelected = checked));
  }

  submitBulkVisitingCardApprove(statusID): void {
    const vstCardList = this.visitingCardApprovals.filter((el) => {
      if (el.isSelected == true) {
        return el;
      }
    });
    if (vstCardList.length == 0) {
      this.notifyService.showError(
        'Please select atleast one Visiting card to approve',
        'Error!'
      );
      return;
    }
    const params = {
      vst_card_lists: vstCardList,
      status: statusID,
      source: 'web',
    };

    this.dashboardService.bulkVisitingCardApprovalAction(params).subscribe(
      (res) => {
        this.response = res;
        if (this.response.status) {
          this.notifyService.showSuccess(this.response.msg);
          this.getMyApprovals();
        } else {
          this.notifyService.showError(this.response.msg);
        }
      },
      (err) => {
        this.notifyService.showError('Internal server error !');
      }
    );
  }

  submitEpaApproval(relID, statusID): void {
    const params = {
      status: statusID,
      rel_id: relID,
    };
    this.dashboardService.epaApproveAction(params).subscribe((res) => {
      this.response = res;
      if (this.response.status) {
        this.notifyService.showSuccess(this.response.msg);
        this.getMyApprovals();
      } else {
        this.notifyService.showError(this.response.msg);
      }
    });
  }

  submitPettyCashApproval(data, statusID): void {
    // console.log(data);
    // console.log('test1--------');
    this.pettyApprObj = {
      rel_id: data.rel_id,
      lvl: data.rel_level,
      status: statusID,
    };
    // console.log('test2-----');
    $('#petty_cash_appr_modal').modal({ backdrop: 'static', keyboard: false });
    // console.log('test3-----');
  }

  submitEpaBulkApproval(statusID): void {
    let msg = 'Approve';
    if (statusID == '0') {
      msg = 'Reject';
    } else {
      msg = 'Approve';
    }
    const epas = this.epaApprovals.filter((element) => {
      if (element.isSelected) {
        return element;
      }
    });
    if (epas.length == 0) {
      this.notifyService.showError(
        `Please select atleast one EPA to ${msg}`,
        'Error!'
      );
      return;
    }
    const params = {
      epa_lists: epas,
      status: statusID,
      source: 'web',
    };

    this.dashboardService.epaBulkApproveAction(params).subscribe((res) => {
      this.response = res;
      if (this.response.status) {
        this.notifyService.showSuccess(this.response.msg);
        this.getMyApprovals();
      } else {
        this.notifyService.showError(this.response.msg);
      }
    });
  }

  submitPettyCashExpenseApproval(relID, statusID): void {
    // console.log(relID);
    this.pettyExpnsApprObj = {
      rel_id: relID,
      status: statusID,
    };
    $('#petty_cash_Expense_appr_modal').modal({
      backdrop: 'static',
      keyboard: false,
    });
  }

  submitWrkplaceApproval(data, statusID): void {
    const params = {
      status: statusID,
      rel_id: data.rel_id,
      prmsn_id: data.txn_id,
      client_url: environment.app_url,
      user_id: data.user_id,
    };
    this.dashboardService.workplaceApproveAction(params).subscribe((res) => {
      if (res.status) {
        this.notifyService.showSuccess(res.msg);
        this.getMyApprovals();
      } else {
        this.notifyService.showError(res.msg);
      }
    });
  }

  checkUncheckAllIDCard(event): void {
    // console.log(event.target.checked);
    const checked = event.target.checked;
    this.idCardApprovals.forEach((item) => (item.isSelected = checked));
  }

  submitIDCardApprove(relID, reqID, statusID): void {
    // alert(relID);
    // return;
    const params = {
      req_id: reqID,
      status: statusID,
      rel_id: relID,
    };
    // console.log(params);
    this.dashboardService.idCardApproveAction(params).subscribe(
      (res) => {
        this.response = res;
        if (this.response.status == true) {
          this.notifyService.showSuccess(this.response.msg, '');
        } else {
          this.notifyService.showError(this.response.msg, '');
        }
        this.getMyApprovals();
      },
      (err) => {
        this.notifyService.showError('Internal server error', '');
      }
    );
  }

  submitBulkIDCardApprove(statusID): void {
    const idCardList = this.idCardApprovals.filter((el) => {
      if (el.isSelected == true) {
        return el;
      }
    });
    if (idCardList.length == 0) {
      this.notifyService.showError(
        `Please select atleast one id card to approve`,
        'Error!'
      );
      return;
    }
    const params = {
      id_card_lists: idCardList,
      status: statusID,
      source: 'web',
    };
    this.dashboardService.bulkIDCardApprovalAction(params).subscribe(
      (res) => {
        this.response = res;
        if (this.response.status) {
          this.notifyService.showSuccess(this.response.msg);
          this.getMyApprovals();
        } else {
          this.notifyService.showError(this.response.msg);
        }
      },
      (err) => {
        this.notifyService.showError('Internal server error !');
      }
    );
  }

  onCloseResolveExpense(): void {
    this.resolveFormExpense.reset();
    this.submit = false;
    this.loading = false;
    this.btnName = 'Approve';
  }

  resolveAward(data, id): void {
    this.awardData = data;
    console.log(this.awardData);
    $(id).modal({ backdrop: 'static', keyboard: false });
    this.resolveForm.patchValue({
      is_approved: 1,
    });
  }

  resolveExpense(data, id): void {
    this.expenseData = data;
    console.log(this.expenseData);
    $(id).modal({ backdrop: 'static', keyboard: false });
    this.resolveFormExpense.patchValue({
      is_approved: 1,
    });
  }

  onSubmitResolveExpense(): void {
    this.submitExp = true;
    if (this.resolveFormExpense.invalid) {
      return;
    } else {
      const resolveForm1 = new FormData();
      resolveForm1.append(
        'status',
        this.resolveFormExpense.get('is_approved').value
      );
      resolveForm1.append(
        'remark',
        this.resolveFormExpense.get('remark').value
      );
      resolveForm1.append('rel_id', this.expenseData.id);
      resolveForm1.append('expns_id', this.expenseData.expns_id);
      resolveForm1.append('upload_source', 'web');
      const chkvalue = this.resolveFormExpense.get('is_approved').value;
      const remarkchk = this.resolveFormExpense.get('remark').value;
      if (chkvalue == 0 && (remarkchk == '' || remarkchk == null)) {
        this.notifyService.showError(`Please Enter Rejection Remark`, 'Error!');
        return;
      }
      // console.log(resolveForm1);
      if (
        chkvalue == 1 &&
        this.expenseData.attachment1 == '' &&
        this.expenseData.attachment2 == ''
      ) {
        Swal.fire({
          title: 'No Bill Found',
          text: 'Do you want to approve it',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes!',
          cancelButtonText: 'No, ',
        }).then((result) => {
          if (result.value) {
            this.submitApiFunction(resolveForm1);
          } else {
            $('#take_action_expense').modal('hide');
            return;
          }
        });
      } else {
        this.submitApiFunction(resolveForm1);
      }
    }
  }

  submitApiFunction(resolveForm1): void {
    this.dashboardService.expenseApprove(resolveForm1).subscribe((res) => {
      this.result = res;
      this.submitExp = false;
      if (this.result.status) {
        $('#take_action_expense').modal('hide');
        this.onCloseResolveExpense();
        this.notifyService.showSuccess(this.result.msg);
      } else {
        this.notifyService.showInfo(this.result.msg);
      }
      this.getMyApprovals();
    });
  }

  openExitupdateModal(modalID, data, id): void {
    $(modalID).modal({ backdrop: 'static', keyboard: false });
    if (id == 1) {
      this.getVouluntaryGrp(data.vltry_id, data.rsn_id);
      this.exitUpdateForm.patchValue({
        exit_id: data.exit_id,
        rpls_rm_username: data.nrm_emp_name,
      });
    }
    if (id == 2) {
      this.extendExit.patchValue({
        exit_id: data.exit_id,
      });
    }
  }

  getVouluntaryGrp(vltryId, rsn_id): void {
    this.dashboardService.getModOptions(18).subscribe((res) => {
      this.response = res;
      this.voltryList = this.response.data;
      this.getReasonsOption(vltryId, rsn_id);

      setTimeout(() => {
        this.exitUpdateForm.patchValue({
          vltry_id: vltryId,
        });
      }, 100);
    });
  }

  getReasonsOption(vlId, rsnID = ''): void {
    this.dashboardService.getReasonsOption(vlId).subscribe((res) => {
      this.response = res;
      this.reasonList = this.response.data;
      setTimeout(() => {
        this.exitUpdateForm.patchValue({
          rsn_id: rsnID,
        });
      }, 100);
    });
  }

  submitExitApprove(
    relID,
    exitId,
    statusID,
    id,
    empId,
    crtrId,
    relLvl,
    reporties_count,
    rpls_rm_id,
    emp_name
  ): void {
    if (reporties_count > 0 && rpls_rm_id == 0 && statusID == 1) {
      this.notifyService.showError(
        'Please update new reporting manager for ' + emp_name + ' reporties',
        ''
      );
      return;
    }
    // console.log('rel level', relLvl);
    let params;
    if (id == 0) {
      this.exitRejectForm.patchValue({
        exit_id: exitId,
        status: statusID,
        rel_id: relID,
        emp_user_id: empId,
      });
      $('#exit_reject_remark').modal({ backdrop: 'static', keyboard: false });
      return;
    } else {
      params = {
        exit_id: exitId,
        status: statusID,
        rel_id: relID,
        approver_remark: '',
        emp_user_id: empId,
        creator_user_id: crtrId,
      };
      if (relLvl == 1) {
        Swal.fire({
          title:
            'Do you want to raise replacement MRF for this exiting Employee ?',
          text: '',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
        }).then((result) => {
          if (result.value) {
            this.dashboardService.exitApprovalAction(params).subscribe(
              (res) => {
                this.response = res;
                if (this.response.status == true) {
                  $('#employee_approver_modal').modal('hide');
                  this.closeExitReson();
                  this.notifyService.showSuccess(this.response.msg, '');
                  if (statusID == 1) {
                    this.createExitEmployeeMrf(params);
                  }
                } else {
                  this.notifyService.showError(this.response.msg, '');
                }
                this.exitApproveForm.reset();
                this.getMyApprovals();
              },
              (err) => {
                this.notifyService.showError('Internal server error', '');
              }
            );
          } else {
            this.exitApprovalRequest(params);
          }
        });
      } else {
        this.exitApprovalRequest(params);
      }
    }
  }

  exitApprovalRequest(params): void {
    // console.log(params);
    this.dashboardService.exitApprovalAction(params).subscribe(
      (res) => {
        this.response = res;
        if (this.response.status == true) {
          this.closeExitReson();
          this.notifyService.showSuccess(this.response.msg, '');
        } else {
          this.notifyService.showError(this.response.msg, '');
        }
        this.exitApproveForm.reset();
        this.getMyApprovals();
      },
      (err) => {
        this.notifyService.showError('Internal server error', '');
      }
    );
  }

  closeExitReson(): void {
    this.exitReject = false;
    this.exitRejectForm.reset();
    $('#exit_reject_remark').modal('hide');
  }

  onSubmitExitRejection(): void {
    this.exitReject = true;
    if (this.exitRejectForm.invalid) {
      return;
    } else {
      this.exitApprovalRequest(this.exitRejectForm.value);
    }
  }

  createExitEmployeeMrf(mrfParams): void {
    // console.log(mrfParams);
    this.talentService.createExitEmployeeMrf(mrfParams).subscribe(
      (res) => {
        this.result = res;
        if (this.result.status) {
          this.encMrfId = this.result.mrf_enc_id;
          this.router.navigate(['/talent/mrf/' + this.encMrfId]);
        } else {
          this.notifyService.showError(this.result.msg);
        }
      },
      (err) => {
        this.notifyService.showError('Internal Server Error');
      }
    );
  }

  submitBulkMrfApprove(statusID): void {
    const mrfList = this.mrfApprovals.filter((el) => {
      if (el.isSelected == true) {
        return el;
      }
    });
    // console.log(mrfList)
    // console.log(statusID)
    const params = {
      mrfs: mrfList,
      status: statusID,
      source: 'web',
      type: 'mrf',
    };
    this.dashboardService.bulkMrfApprovalAction(params).subscribe(
      (res) => {
        this.response = res;
        if (this.response.status) {
          this.notifyService.showSuccess(this.response.msg);
          this.getMyApprovals();
        } else {
          this.notifyService.showError(this.response.msg);
        }
      },
      (err) => {
        this.notifyService.showError('Internal server error !');
      }
    );
  }

  checkUncheckAllMRf(event): void {
    console.log(event.target.checked);
    const checked = event.target.checked;
    this.mrfApprovals.forEach((item) => (item.isSelected = checked));
  }

  submitBulkTransferApprove(statusID): void {
    const mrfList = this.transferApprovals.filter((el) => {
      if (el.isSelected == true) {
        return el;
      }
    });
    const params = {
      mrfs: mrfList,
      status: statusID,
      source: 'web',
      type: 'transfer',
    };
    this.dashboardService.bulkMrfApprovalAction(params).subscribe(
      (res) => {
        this.response = res;
        if (this.response.status) {
          this.notifyService.showSuccess(this.response.msg);
          this.getMyApprovals();
        } else {
          this.notifyService.showError(this.response.msg);
        }
      },
      (err) => {
        this.notifyService.showError('Internal server error !');
      }
    );
  }

  submitMrfApprove(relId, statusID, rel_groupId, txn_Id): void {
    const params = {
      rel_id: relId,
      status: statusID,
      rel_group_id: rel_groupId,
      txn_id: txn_Id,
      source: 'web',
      type: 'mrf',
    };

    this.dashboardService.mrfApprovalAction(params).subscribe(
      (res) => {
        this.response = res;
        if (this.response.status == true) {
          this.notifyService.showSuccess(this.response.msg, '');
          this.mrfApproveForm.reset();
        } else {
          this.notifyService.showError(this.response.msg, '');
        }
        this.getMyApprovals();
      },
      (err) => {
        this.notifyService.showError('Internal server error', '');
      }
    );
  }

  closepettyReqModal(): void {
    $('#petty_cash_appr_modal').modal('hide');
    this.pettyReqRejRemark = '';
  }

  get exitApproveFormControls() {
    return this.exitApproveForm.controls;
  }

  exitApproveFormField(): void {
    this.exitApproveForm = new FormGroup({
      remark: new FormControl(''),
      exit_id: new FormControl('', Validators.required),
      status: new FormControl('', Validators.required),
    });
  }

  closepettyExpnsModal(): void {
    $('#petty_cash_Expense_appr_modal').modal('hide');
    this.pettyExpnsRejRemark = '';
  }

  approveRejPettyRequest(): void {
    if (!this.pettyReqRejRemark && this.pettyApprObj.status == 0) {
      this.notifyService.showError('Please Enter Remark', 'Info!');
      return;
    }
    this.pettyApprObj.approver_remark = this.pettyReqRejRemark;
    this.dashboardService
      .pettyCashApproveAction(this.pettyApprObj)
      .subscribe((res) => {
        if (res.status) {
          this.notifyService.showSuccess(res.msg);
          this.getMyApprovals();
          this.closepettyReqModal();
        } else {
          this.notifyService.showError(res.msg);
        }
      });
  }

  rejectPettyExpense(): void {
    if (!this.pettyExpnsRejRemark && this.pettyExpnsApprObj.status == 0) {
      this.notifyService.showError('Please Enter Remark', 'Info!');
      return;
    }
    this.pettyExpnsApprObj.approver_remark = this.pettyExpnsRejRemark;
    this.dashboardService
      .pettyCashExpenseApproveAction(this.pettyExpnsApprObj)
      .subscribe((res) => {
        if (res.status) {
          this.notifyService.showSuccess(res.msg);
          this.getMyApprovals();
          this.closepettyExpnsModal();
        } else {
          this.notifyService.showError(res.msg);
        }
      });
  }

  getMyApprovals(): void {
    this.dashboardService.getMyApprovals().subscribe(
      (res) => {
        console.log(res);
        this.approvals = res;
        this.marqueeText = this.approvals.marqueeText;
        this.mrfApprovals = this.approvals.data.mrf_approvals;
        this.mrfApprovalsCount = this.approvals.has_mrf_approvals;
        this.napsMrfApprovals = this.approvals.data.naps_mrf_approvals;
        this.napsMrfApprovalsCount = this.approvals.has_naps_mrf_approvals;
        this.transferApprovals = this.approvals.data.transfer_approvals;
        this.transferApprovalsCount = this.approvals.has_transfer_approvals;
        this.exitApprovals = this.approvals.data.exit_approvals;
        this.exitApprovalsCount = this.approvals.has_exit_approvals;
        this.expensesCount = this.approvals.data.expense_approvals.expenseCount;
        this.smarttripCount =
          this.approvals.data.expense_approvals.smarttripCount;
        this.expenseApprovals = this.approvals.data.expense_approvals.expenses;
        this.smarttripApprovals =
          this.approvals.data.expense_approvals.smarttrip;
        this.ongcpassCount = this.approvals.has_ongc_pass_approvals;
        this.ongcApprovals = this.approvals.data.ongc_pass_approvals;
        this.awardApprovals = this.approvals.data.award_approvals;
        this.awardApprovalsCount = this.approvals.has_award_approvals;
        this.idCardApprovalsCount = this.approvals.has_id_card_approvals;
        this.idCardApprovals = this.approvals.data.id_card_approvals;
        this.epaApprovalsCount = this.approvals.has_epa_approvals;
        this.epaApprovals = this.approvals.data.epa_approvals;
        this.pettyCashApprovalCount = this.approvals.has_petty_cash_approvals;
        this.pettyCashExpenseApprovalCount =
          this.approvals.has_petty_cash_expense_approvals;
        this.pettyCashExpenseApprovals =
          this.approvals.data.petty_cash_expense_approvals;
        this.pettyCashApprovals = this.approvals.data.petty_cash_approvals;
        this.workPlaceApprovalsCount = this.approvals.has_wp_approvals;
        this.visitingCardApprovalsCount =
          this.approvals.has_visiting_card_approvals;
        this.visitingCardApprovals =
          this.approvals.data.visiting_card_approvals;
        this.pendingEmpBuddyCount = this.approvals.has_pending_emp_map_buddy;
        this.buddyPendingEmployeeList =
          this.approvals.data.pending_emp_map_buddy;

          this.committeeDataCount = this.approvals.has_idea_committee_approvals;
          this.committeeData =  this.approvals.data.idea_committee_approvals;
        
        this.isLoading = false;
      },
      (err) => {}
    );
  }

  approveRej(data, AR): void {
    // console.log(data, AR);
    if (AR === 1) {
      this.leaveServe
        .approveLeave({ leave_id: data.lv_id })
        .subscribe((res) => {
          if (res.status) {
            this.notifyService.showSuccess(res.msg, 'Approved');
            data.trans.forEach((el) => {
              if (el.color === '') {
                el.color = 'primary';
              }
            });
            data.pending = 0;
            data.approved = data.trans.length;
            return false;
          }
          this.notifyService.showError(res.msg, 'Approved');
          return false;
        });
    } else if (AR === 2) {
      this.leaveServe.rejectLeave({ leave_id: data.lv_id }).subscribe((res) => {
        if (res.status) {
          data.trans.forEach((el) => {
            if (el.color === '') {
              el.color = 'warn';
            }
          });
          data.pending = 0;
          data.rejected = data.trans.length;
          this.notifyService.showSuccess(res.msg, 'Rejected');
          return false;
        }
        this.notifyService.showError(res.msg, 'Rejected');
        return false;
      });
    } else if (AR === 3) {
      // approved reject
      this.leaveServe
        .rejectLeave({
          leave_id: data.lv_id,
          both_is_approved: 'both_is_approved',
        })
        .subscribe((res) => {
          if (res.status) {
            data.trans.forEach((el) => {
              if (el.color === '') {
                el.color = 'warn';
              }
            });
            data.pending = 0;
            data.approved = 0;
            data.rejected = data.trans.length;
            this.notifyService.showSuccess(res.msg, 'Rejected');
            return false;
          }
          this.notifyService.showError(res.msg, 'Rejected');
          return false;
        });
    }
  }

  onSubmitRegulariseFrom(): void {
    this.submit = true;
    if (this.regulariseFrom.invalid == true) {
      return;
    }
    this.dashboardService
      .regulariseApprove(this.regulariseFrom.value)
      .subscribe(
        (res) => {
          this.response = res;
          if (this.response.status) {
            this.notifyService.showSuccess(this.response.msg, 'Success');
            this.regulariseFrom.reset();
            this.getAttendanceReguarisationRequest();
            $('#regularise_modal').modal('hide');
          } else {
            this.notifyService.showError(this.response.msg, 'Error');
          }
          this.submit = false;
        },
        (err) => {
          this.notifyService.showError('Internal Server Error !', '');
          this.submit = false;
        }
      );
  }

  approveRejRegularise(data, statusReq): void {
    //console.log(data);
    //console.log(statusReq);
    if (statusReq == 1) {
      Swal.fire({
        title: 'Are you sure to approve this request ?',
        text: '',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Approve',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.value) {
          this.regulariseFrom.patchValue({
            txn_id: data.txn_id,
            status: statusReq,
            remark: 'Approved',
          });
          this.onSubmitRegulariseFrom();
        }
      });
    } else {
      this.regulariseFrom.patchValue({
        txn_id: data.txn_id,
        status: statusReq,
        remark: '',
      });
      this.submit = false;
      $('#regularise_modal').modal({ backdrop: 'static', keyboard: false });
    }
  }

  checkUncheckAllLeave(event): void {
    // console.log(event.target.checked);
    const checked = event.target.checked;
    this.leavesData.forEach((item) => (item.isSelected = checked));
  }

  bulkApproval(): void {
    // console.log(this.leavesData);
    let data = [];
    data = this.leavesData.filter((res) => res.isSelected === true);

    if (data.length === 0) {
      alert('Please select at lease one leave');
      return;
    } else {
      // console.log(data);
      this.loadingBulkApprove = true;
      this.leaveServe.builkApproveLeave(data).subscribe((res) => {
        if (res.status) {
          data = [];
          this.notifyService.showSuccess(res.msg, 'Approved');
          this.leavesData.forEach((item) => (item.isSelected = false));
          this.LeaveRegister();
          return false;
        }
        this.loadingBulkApprove = false;
        this.notifyService.showError(res.msg, 'Approved');
        return;
      });
    } // end of else
  }

  submitBulkExitApprove(statusID): void {
    const exitList = this.exitApprovals.filter((el) => {
      if (el.isSelected == true) {
        return el;
      }
    });
    if (statusID == 1) {
      for (let index = 0; index < exitList.length; index++) {
        const el = exitList[index];
        if (el.reporties_count > 0 && el.rpls_rm_id == 0) {
          this.notifyService.showError(
            'Please update new reporting manager for ' +
              el.emp_name +
              ' reporties',
            ''
          );
          return;
        }
      }
    }

    const params = {
      exit_data: exitList,
      status: statusID,
      remark: '',
    };
    this.dashboardService.bulkExitApprovalAction(params).subscribe(
      (res) => {
        this.response = res;
        if (this.response.status) {
          this.notifyService.showSuccess(this.response.msg);
          this.getMyApprovals();
        } else {
          this.notifyService.showError(this.response.msg);
        }
      },
      (err) => {
        this.notifyService.showError('Internal Server Error !');
      }
    );
  }

  submitTransferApprove(relId, statusID, rel_groupId, txn_Id, rel_level): void {
    const params = {
      rel_id: relId,
      status: statusID,
      rel_group_id: rel_groupId,
      txn_id: txn_Id,
      source: 'web',
      type: 'transfer',
      rel_level: rel_level
    };
    this.dashboardService.mrfApprovalAction(params).subscribe(
      (res) => {
        this.response = res;
        if (this.response.status == true) {
          this.notifyService.showSuccess(this.response.msg, '');
          this.mrfApproveForm.reset();
        } else {
          this.notifyService.showError(this.response.msg, '');
        }
        this.getMyApprovals();
      },
      (err) => {
        this.notifyService.showError('Internal server error', '');
      }
    );
  }

  checkUncheckAllTransfer(event): void {
    // console.log(event.target.checked);
    const checked = event.target.checked;
    this.transferApprovals.forEach((item) => (item.isSelected = checked));
  }

  getAttendanceReguarisationRequest(): void {
    this.dashboardService.getAttendanceReguarisationRequest().subscribe(
      (res) => {
        // console.log(res);
        this.result = res;
        this.attRegulariseData = this.result.data;
        this.attRegulariseDataCount = this.result.count;
      },
      (err) => {}
    );
  }

  LeaveRegister(): void {
    this.leaveServe
      .EmpLeaveRegister({
        forms: { is_approved: 0 },
        pageIndex: this.page,
        limit: this.pageSize,
      })
      .subscribe((res) => {
        this.response = [];
        this.response = res;
        if (this.response.status) {
          this.leavesData = this.response.data.data;
          this.count = this.response.data.total;
          this.from = this.response.data.from;
          this.to = this.response.data.to;
        } else {
          this.notifyService.showInfo(this.response.msg, 'Info!');
        }
      });
  }

  submitNapsMrfApprove(relId, statusID, rel_groupId, txn_Id, createdBy): void {
    const params = {
      rel_id: relId,
      status: statusID,
      rel_group_id: rel_groupId,
      txn_id: txn_Id,
      source: 'web',
      creater_id: createdBy,
    };
    this.dashboardService.napsMrfApprovalAction(params).subscribe(
      (res) => {
        this.response = res;
        if (this.response.status == true) {
          this.notifyService.showSuccess(this.response.msg, '');
        } else {
          this.notifyService.showError(this.response.msg, '');
        }
        this.getMyApprovals();
      },
      (err) => {
        this.notifyService.showError('Internal server error', '');
      }
    );
  }

  submitVisitingCardApprove(relID, reqID, statusID): void {
    const params = {
      req_id: reqID,
      status: statusID,
      rel_id: relID,
    };
    console.log(params);
    this.dashboardService.visitCardApproveAction(params).subscribe(
      (res) => {
        this.response = res;
        if (this.response.status == true) {
          this.notifyService.showSuccess(this.response.msg, '');
        } else {
          this.notifyService.showError(this.response.msg, '');
        }
        this.getMyApprovals();
      },
      (err) => {
        this.notifyService.showError('Internal server error', '');
      }
    );
  }

  submitOngcPassApprove(reqID, relID, statusID): void {
    const params = {
      req_id: reqID,
      rel_id: relID,
      status: statusID,
    };
    console.log(params);
    this.dashboardService.ongcApproveAction(params).subscribe(
      (res) => {
        this.response = res;
        if (this.response.status == true) {
          this.notifyService.showSuccess(this.response.msg, '');
        } else {
          this.notifyService.showError(this.response.msg, '');
        }
        this.getMyApprovals();
      },
      (err) => {
        this.notifyService.showError('Internal server error', '');
      }
    );
  }

  onCloseResolve(): void {
    this.resolveForm.reset();
    this.submit = false;
    this.loading = false;
    this.btnName = 'Approve';
    console.log('close');
  }

  onSubmitResolve(): void {
    this.submit = true;
    if (this.resolveForm.invalid) {
      return;
    }
    const resolveForm = new FormData();
    resolveForm.append(
      'is_approved',
      this.resolveForm.get('is_approved').value
    );
    resolveForm.append('remark', this.resolveForm.get('remark').value);
    resolveForm.append('rel_id', this.awardData.rel_id);
    // tslint:disable-next-line: deprecation
    this.dashboardService.awardApproveAction(resolveForm).subscribe((res) => {
      this.result = res;
      if (this.result.status) {
        $('#take_action').modal('hide');
        this.onCloseResolve();
        this.notifyService.showSuccess(this.result.msg);
      } else {
        this.notifyService.showInfo(this.result.msg);
      }
      this.getMyApprovals();
    });
  }

  closeExitDateModal(): void {
    this.updateExitDate = false;
    this.extendExit.reset();
    $('#exit_date_modal').modal('hide');
  }

  onSubmitExitDate(): void {
    this.updateExitDate = true;
    if (this.extendExit.invalid) {
      return;
    } else {
      this.talentService
        .updateExtendDate(this.extendExit.value)
        .subscribe((res) => {
          if (res.status) {
            this.notifyService.showSuccess(res.msg, 'Success!');
            this.closeExitDateModal();
            this.getMyApprovals();
          } else {
            this.notifyService.showError(res.msg, 'Error!');
          }
        });
    }
  }

  closeExitUpdateModal(): void {
    this.updateExit = false;
    this.exitUpdateForm.reset();
    $('#exit_update_modal').modal('hide');
  }

  onUpdateExit(): void {
    this.updateExit = true;
    if (this.exitUpdateForm.invalid) {
      return;
    } else {
      this.dashboardService
        .exitUpdate(this.exitUpdateForm.value)
        .subscribe((res) => {
          if (res.status) {
            this.closeExitUpdateModal();
            this.getMyApprovals();
            this.notifyService.showSuccess(res.msg, 'Success!');
          } else {
            this.notifyService.showError(res.info, 'Error!');
          }
        });
    }
  }

  changeExitType(event): void {
    this.getReasonsOption(event.target.value);
  }

  get exitUpdateErrorMsg(): any {
    return this.exitUpdateForm.controls;
  }

  searchEmp(): void {
    if (this.exitUpdateForm.get('rpls_rm_username').value) {
      this.generalServ
        .searchEmployee(this.exitUpdateForm.get('rpls_rm_username').value)
        .subscribe(
          (res) => {
            this.result = res;
            if (this.result.status) {
              this.exitUpdateForm.patchValue({
                rpls_rm_username:
                  this.result.data[0].username +
                  ' - ' +
                  this.result.data[0].name,
                rpls_rm_id: this.result.data[0].id,
              });
              // this.empID = this.result.data[0].id;
              // this.isSearch = true;
            } else {
              this.exitUpdateForm.patchValue({
                rpls_rm_username: '',
                rpls_rm_id: '',
              });
              this.notifyService.showError(this.result.msg, 'Info!');
            }
          },
          (err) => {}
        );
    } else {
      this.exitUpdateForm.patchValue({
        rpls_rm_username: '',
        rpls_rm_id: '',
      });
      this.notifyService.showInfo('Please Enter User Id', 'Info!');
    }
  }

  approvedIdea(item,status): void{
    const params = {
      id: item.id,
      status: status,
      rel_id: item.rel_id,
      remark: this.commt_remark
    };
    console.log(params);
    this.dashboardService.ideaCommtdApproveAction(params).subscribe(
      (res) => {
        this.response = res;
        if (this.response.status == true) {
          this.notifyService.showSuccess(this.response.msg, '');
        } else {
          this.notifyService.showError(this.response.msg, '');
        }
        this.getMyApprovals();
      },
      (err) => {
        this.notifyService.showError('Internal server error', '');
      }
    );
  }


}
